export default function (state = "", action) {
    switch (action.type) {
        case "GET_EXPERT_INFO":
            return action.payload;
            break;
        default:
            return state;
    }
}